import React from 'react';

export default function ManualRevenueFeed({ manual }) {
  return (
    <div className="bg-white rounded-2xl shadow p-4">
      <h2 className="text-xl font-bold mb-2">Manual Revenue Feed</h2>
      <ul className="divide-y">
        {manual.map((entry, i) => (
          <li key={i} className="py-2 flex justify-between">
            <div>
              <span className="font-semibold">{entry.description}</span>
              <span className="text-sm text-gray-400 ml-2">{entry.source}</span>
            </div>
            <div>
              <span>€{entry.amount.toLocaleString()}</span>
              <span className="text-xs text-gray-400 ml-2">
                {new Date(entry.date).toLocaleDateString()}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
